import { AlertTriangle } from 'lucide-react';
import type { WorkspaceNameConflict } from '@mg/shared';

/**
 * Shown when a Brand Workspace name is already taken: the message plus the existing workspace's
 * admins (as mailto links) so the person can request access instead of creating a duplicate.
 */
export function WorkspaceNameConflictNotice({ conflict }: { conflict: WorkspaceNameConflict }) {
  return (
    <div
      role="alert"
      className="flex gap-3 rounded-lg border border-amber-200 dark:border-warning-dark/30 bg-amber-50 dark:bg-warning-dark-tint px-4 py-3 text-sm"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-500 dark:text-warning-dark" aria-hidden />
      <div className="space-y-2">
        <p className="text-amber-900 dark:text-warning-dark">{conflict.message}</p>
        {conflict.admins.length > 0 ? (
          <ul className="space-y-1">
            {conflict.admins.map((a) => (
              <li key={a.email}>
                <a
                  href={`mailto:${a.email}`}
                  className="font-medium text-link hover:text-action-hover hover:underline"
                >
                  {a.displayName || a.email}
                </a>
                {a.displayName && <span className="text-amber-800 dark:text-warning-dark"> · {a.email}</span>}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-amber-800 dark:text-warning-dark">
            No workspace admins are listed — ask your Tenant Admin for access.
          </p>
        )}
      </div>
    </div>
  );
}
